import React, {Component, Suspense, lazy} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { FilterProvider } from './contexts/FilterContext';
import { AuthProvider } from './contexts/AuthContext';
import queryClient from './api/queryClient';
import theme from './theme';

const SelectPage = lazy(() => import('./pages/select/SelectPage'));
const RegisterPage = lazy(() => import('./pages/register/RegisterPage'));
const LoginPage = lazy(() => import('./pages/login/LoginPage'));
const ProfilePage = lazy(() => import('./pages/profile/ProfilePage'));
const DiseasePage = lazy(() => import('./pages/disease/DiseasePage'));
const FindingPage = lazy(() => import('./pages/finding/FindingPage'));
const CommentsPage = lazy(() => import('./pages/comments/CommentsPage'));
const NotFoundPage = lazy(() => import('./pages/notFound/NotFoundPage'));

const RouteFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <CircularProgress />
  </Box>
);
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            px: 2,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Something went wrong.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            An unexpected error occurred. Try reloading the page.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}


function App() {

  const [selectedEntity, setSelectedEntity] = React.useState([]);
  const [filterSelect, setFilterSelect] = React.useState([])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
      <Router>
      <AuthProvider>
      <FilterProvider>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
              <Route exact path="/" element={<SelectPage selectedEntity={selectedEntity} setSelectedEntity={setSelectedEntity} filterSelect={filterSelect} setFilterSelect={setFilterSelect}/>} />
              <Route exact path="/register" element={<RegisterPage />} />
              <Route exact path="/login" element={<LoginPage />} />
              <Route exact path="/profile" element={<ProfilePage />} />
              <Route exact path="/disease" element={<DiseasePage selected={selectedEntity} setSelected={setSelectedEntity} filtered={filterSelect} setFiltered={setFilterSelect}/>} />
              <Route exact path="/finding" element={<FindingPage selected={selectedEntity} setSelected={setSelectedEntity} filtered={filterSelect} setFiltered={setFilterSelect}/>} />
              <Route exact path="/comments" element={<CommentsPage />} />
              <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </Suspense>
      </FilterProvider>
      </AuthProvider>
      </Router>
      </QueryClientProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
  


export default App;
